import styled from "styled-components";
import Navbar from "../components/Navbar";
const Services = () => {
  return (
    <Wrapper>
      <Navbar />
    </Wrapper>
  );
};
const Wrapper = styled.div``;

export default Services;
